import styled from 'styled-components';
import ProjectExample from '../../../../../assets/project-example-1.png';

export const Item = styled.div`
  background: url(${ProjectExample}) center center no-repeat;
  background-size: cover;

  height: 650px;
  width: 360px;
`;

export const PortfolioItemOverlay = styled.div`
  position: relative;

  height: 100%;
  width: 360px;

  ::after {
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    top: 0;

    background: rgba(39, 39, 39, 0.7);
    mix-blend-mode: multiply;

    transition: 0.5s;

    content: '';
  }

  :hover:after {
    opacity: 0.1;
  }
`;

export const PortfolioItemContent = styled.div`
  z-index: 1;

  position: absolute;
  height: 60%;
  left: 20px;
  top: 15%;

  header {
    h1 {
      font-weight: 800;
      font-size: 40px;
      line-height: 60px;
      color: #ffffff;
    }

    h2 {
      font-weight: 800;
      font-size: 65px;
      line-height: 97px;

      color: #ffffff;
    }
  }

  div {
    position: absolute;
    bottom: 0;
    left: 25px;

    transform-origin: 0 0;
    transform: rotate(90deg);

    p {
      font-weight: bold;
      font-size: 18px;
      line-height: 27px;

      color: #ffffff;
    }
  }
`;
